import { useRecoilState } from 'recoil';
import { modalState, postIDState } from '../atom/modalAtom';
import Modal from 'react-modal';
import {
  EmojiHappyIcon,
  PhotographIcon,
  XIcon,
} from '@heroicons/react/outline';
import { useEffect, useRef, useState } from 'react';
import { db } from '../firebase';
import {
  addDoc,
  collection,
  doc,
  onSnapshot,
  serverTimestamp,
} from 'firebase/firestore';
import Moment from 'react-moment';
import { userState } from '../atom/userAtom';
import { useRouter } from 'next/router';
export default function CommentModal() {
  const [open, setOpen] = useRecoilState(modalState);
  const [postID] = useRecoilState(postIDState);
  const [post, setPost] = useState({});
  const [input, setInput] = useState('');
  const [currentUser] = useRecoilState(userState);
  const filePickerRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);

  const router = useRouter();

  const addImageToPost = (e) => {
    const reader = new FileReader();
    if (e.target.files[0]) {
      reader.readAsDataURL(e.target.files[0]);
    }

    reader.onloadend = (readerEvent) => {
      setSelectedFile(readerEvent.target.result);
    };
  };

  useEffect(() => {
    onSnapshot(doc(db, 'posts', postID), (snapshot) => {
      setPost(snapshot);
    });
  }, [postID, db]);

  async function sendComment() {
    await addDoc(collection(db, 'posts', postID, 'comments'), {
      comment: input,
      name: currentUser.name,
      username: currentUser.username,
      useImg: currentUser.userImg,
      timestamp: serverTimestamp(),
      userId: currentUser.uid,
    });

    setOpen(false);
    setInput('');
    router.push(`/posts/${postID}`);
  }

  return (
    <div>
      {open && (
        <Modal
          isOpen={open}
          onRequestClose={() => setOpen(false)}
          className="max-w-lg w-[90%]  absolute top-24 left-[50%] translate-x-[-50%] bg-gray-900 border-2 border-gray-200 rounded-xl shadow-md"
        >
          <div className="p-1">
            <div className="border-b border-gray-200 py-2 px-1.5">
              <div
                onClick={() => setOpen(false)}
                className="hoverEffect w-10 h-10 flex items-center justify-center"
              >
                <XIcon className="h-[23px] text-gray-200 p-0" />
              </div>
            </div>
            <div className="p-2 flex items-center space-x-1 relative">
              <span className="w-0.5 h-full z-[-1] absolute left-8 top-11 bg-gray-300" />

              <img
                className="h-11 w-11 rounded-full mr-4 "
                src={post?.data()?.useImg}
                alt="user-img"
              />

              <h4 className="font-bold text-[15px] sm:text-[16px] hover:underline text-gray-100">
                {post?.data()?.name}
              </h4>
              <span className="text-sm sm:text-[15px] text-gray-300">
                @{post?.data()?.username}{' '}
              </span>
            </div>
            <p className="text-gray-300 text-[15px] sm:text-[16px] ml-16 mb-2">
              {post?.data()?.text}
            </p>

            <div className="flex  p-3 space-x-3">
              <img
                src={currentUser.userImg}
                alt="user-img"
                className="h-11 w-11 rounded-full cursor-pointer hover:brightness-95"
              />
              <div className="w-full divide-y divide-gray-200 ">
                <div className="">
                  <textarea
                    className="w-full border-none focus:ring-0 text-lg placeholder-gray-200 tracking-wide min-h-[50px] text-gray-200 bg-gray-900"
                    rows="2"
                    placeholder="write a comment "
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                  ></textarea>
                </div>

                <div className="flex items-center justify-between pt-2.5">
                  <div className="flex">
                    <div
                      className=""
                      onClick={() => filePickerRef.current.click()}
                    >
                      <PhotographIcon className="h-10 w-10 hoverEffect p-2 text-sky-500 hover:bg-sky-100" />
                      <input
                        type="file"
                        hidden
                        ref={filePickerRef}
                        onChange={addImageToPost}
                      />
                    </div>
                    <EmojiHappyIcon className="h-10 w-10 hoverEffect p-2 text-sky-500 hover:bg-sky-100" />
                  </div>
                  <button
                    onClick={sendComment}
                    disabled={!input.trim()}
                    className="bg-blue-400 text-white px-4 py-1.5 rounded-full font-bold shadow-md hover:brightness-95 disabled:opacity-50  transition ease-in-out delay-150  hover:-translate-y-1 hover:scale-110 hover:bg-blue-500 "
                  >
                    Comment
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}
